import {TranslateService} from "@ngx-translate/core";
import {EventEmitter} from "@angular/core";
import { of } from "rxjs";

export const translateServiceMock: Partial<TranslateService> = {
  instant(key: string | Array<string>, interpolateParams?: any): any {
    return 'translated_token';
  },
  get: (key: string | string[], params?: any) => of('translated_token'),
  onLangChange: new EventEmitter()
}


export const advancedTranslateServiceMock: Partial<TranslateService> = {
  instant(key: string | Array<string>, interpolateParams?: any): any {
    const interpolation = interpolateParams?  ` ${JSON.stringify(interpolateParams)}`: ''
    return `${key}${interpolation}`;
  },
  onLangChange: new EventEmitter()
}
